<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">別アイコンファイル登録</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <h1>アイコン情報</h1>
          <div class="column-list">
            <label class="list-input-title">アイコンコード</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1507Model.iconCode" [style.width.rem]="3" id="txt_IconCode" #txt_IconCode readonly>
            </div>
            <label class="list-input-title">アイコン名</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1507Model.iconName" [style.width.rem]="22" readonly>
            </div>
            <label class="list-input-title">グループ</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1507Model.iconGroup" [style.width.px]="200" readonly>
            </div>
            <label class="list-input-title">アイコン区分</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1507Model.iconDiv" [style.width.px]="200" readonly>
            </div>
            <label class="list-input-title">配置区分</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1507Model.arrangeDiv" [style.width.px]="200" readonly>
            </div>
            <label class="list-input-title">アイコン説明</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1507Model.iconExplain" [style.width.rem]="22" readonly>
            </div>
            <label class="list-input-title">出力区分</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1507Model.outputDiv" [style.width.px]="450" readonly>
            </div>
          </div>
        </div>

        <div>
          <h1>ファイル情報</h1>
          <div class="element-column">
            <div class="column-list">
              <label class="list-input-title">使用開始受注コード</label>
              <div class="list-input-content">
                <app-order-code-text-input id="txt_StartOrderCode" #txt_StartOrderCode [subid]="'txt_StartOrderCode'"
                  [catalogIDField]="lbl_StartDelivCatalogId" [disabled]="!kymw1507Model.startOrderCodeEnabled"
                  [(ngModel)]="kymw1507Model.startOrderCode" [tabindex]="0" [required]="true" class="deliv-catalog">
                </app-order-code-text-input>
                <app-checkbox-label id="chk_NotDesignateStart" #chk_NotDesignateStart [subid]="'chk_NotDesignateStart'"
                  label="指定なし" [(ngModel)]="kymw1507Model.notDesignateStart" (change)="eventNotDesignateStart_CLICKHandler()"
                  autofocus="true" [tabindex]="0" [style.margin-top.px]="4">
                </app-checkbox-label>
              </div>
              <label class="list-input-title">使用開始配達企画回(翌週)</label>
              <div class="list-input-content">
                <input type="text" class="deliv-catalog" id="lbl_StartDelivCatalogId" #lbl_StartDelivCatalogId readonly/>
              </div>
              <label class="list-input-title">使用終了受注コード</label>
              <div class="list-input-content">
                <app-order-code-text-input id="txt_EndOrderCode" #txt_EndOrderCode [subid]="'txt_EndOrderCode'"
                  [catalogIDField]="lbl_EndDelivCatalogId" [disabled]="!kymw1507Model.endOrderCodeEnabled"
                  [(ngModel)]="kymw1507Model.endOrderCode" [tabindex]="0" [required]="true">
                </app-order-code-text-input>
                <app-checkbox-label id="chk_NotDesignateStart" #chk_NotDesignateStart [subid]="'chk_NotDesignateStart'"
                  label="指定なし" [(ngModel)]="kymw1507Model.notDesignateEnd" (change)="eventNotDesignateEnd_CLICKHandler()" [tabindex]="0" [style.margin-top.px]="4">
                </app-checkbox-label>
              </div>
              <label class="list-input-title">使用終了配達企画回(翌週)</label>
              <div class="list-input-content">
                <input type="text" class="deliv-catalog" id="lbl_EndDelivCatalogId" #lbl_EndDelivCatalogId readonly/>
              </div>
              <label class="list-input-title">アイコンファイル(通常)</label>
              <div class="list-input-content">
                <input type="text" id="txti_ImageFileNormal" class="text-label-required-not-editable input-with-button" readonly="true"
                  [(ngModel)]="kymw1507Model.imageFileNameNormal" [tabindex]="0" plessInputTextSub [restrict]="'[ -￮]'"/>
                <button id="btn_ImageNormal" #btn_ImageNormal class="btn-secondary btn-select" (click)="eventImageNormal_ClickHandler()" [tabindex]="0">選択</button>
              </div>
              <label class="list-input-title">アイコンファイル(大)</label>
              <div class="list-input-content">
                <input type="text" id="txti_ImageFileBig" class="text-label-required-not-editable input-with-button" readonly="true"
                  [(ngModel)]="kymw1507Model.imageFileNameBig" [tabindex]="0" plessInputTextSub [restrict]="'[ -￮]'">
                <button id="btn_ImageBig" class="btn-secondary btn-select" (click)="eventImageBig_ClickHandler()" [tabindex]="0">選択</button>
              </div>
              <label class="list-input-title">アイコンファイル(モバイル)</label>
              <div class="list-input-content">
                <input type="text" id="txti_ImageFileMobile" class="text-label-required-not-editable input-with-button" readonly="true"
                  [(ngModel)]="kymw1507Model.imageFileNameMobile" [tabindex]="0" plessInputTextSub [restrict]="'[ -￮]'">
                <button id="btn_ImageMobile" class="btn-secondary btn-select" (click)="eventImageMobile_ClickHandler()" [tabindex]="0">選択</button>
              </div>
            </div>
            
            <div class="element-row">
              <div [style.width.px]="180" [style.height.px]="150"></div>
              <div class="element-column icon-file-wrapper">
                <label>通常</label>
                <div class="img-wrapper">
                  <img src={{kymw1507Model.imageFileUrlNormal}} *ngIf="kymw1507Model.imageFileUrlNormal !== ''">
                </div>
              </div>
              <div class="element-column icon-file-wrapper">
                <label>大</label>
                <div class="img-wrapper">
                  <img src={{kymw1507Model.imageFileUrlBig}} *ngIf="kymw1507Model.imageFileUrlBig !== ''">
                </div>
              </div>
              <div class="element-column icon-file-wrapper">
                <label>モバイル</label>
                <div class="img-wrapper">
                  <img src={{kymw1507Model.imageFileUrlMobile}} *ngIf="kymw1507Model.imageFileUrlMobile !== ''">
                </div>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">アイコン代替テキスト</label>
              <div class="list-input-content">
                <input type="text" [(ngModel)]="kymw1507Model.iconAlternativeText" [style.width.px]="380" [maxLength]="25"
                  plessInputTextSub [restrict]="'[ -￮]'" [fullOnly]="true">
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_add" class="btn-primary" (click)="eventAdd_CLICKHandler()"
            forcedEnabledMode="none" [tabindex]="0">追加</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
